import {
  MapPlaceSuggestionCustomFields,
  MAP_DATA_SERVICE_DATA_SET,
  stateAcronym
} from 'types';
import Util from 'utilities/helper.util';

export const shortenState = (text: string) => {
  let newText = '';
  const stateKeys = Object.keys(stateAcronym);

  for (const stateKey of stateKeys) {
    if (text.includes(stateKey)) {
      const reg = new RegExp(`,\\s${stateKey},?`);
      newText = text.replace(reg, ` ${stateAcronym[stateKey]}`);
      break;
    }
  }

  return newText || text;
};

const arcGISWorldGeocodingLabelTrim = (
  label: string,
  saveHistory?: boolean
) => {
  return label.split(',').length > 0 && !saveHistory
    ? shortenState(label.substring(0, label.length - 5).trim())
    : shortenState(label);
};

export const optimizeLabel = (
  scope: string,
  label: string,
  customFields: MapPlaceSuggestionCustomFields,
  arcgisWorldGeocoding?: boolean,
  arcgisWorldGeocodingSaveHistory?: boolean
) => {
  switch (scope) {
    case MAP_DATA_SERVICE_DATA_SET.GNAF: {
      if (arcgisWorldGeocoding) {
        return arcGISWorldGeocodingLabelTrim(
          label,
          arcgisWorldGeocodingSaveHistory
        );
      }
      const regionIndex = label.lastIndexOf(customFields.locality);
      const addressPart1 = label.substr(0, regionIndex);
      const addressPart2 = label.substr(regionIndex, label.length);
      let addressPart1Arr = addressPart1.split(' ');
      let addressPart2Arr =
        addressPart2.indexOf(', ') !== -1
          ? addressPart2.split(', ')
          : addressPart2.split(' ');
      addressPart1Arr = addressPart1Arr.map((l: string) => {
        return Util.toTitleCase(l);
      });
      addressPart2Arr = addressPart2Arr.map((l: string) => {
        return l === customFields.region ? l : Util.toTitleCase(l);
      });
      let newLabel = `${addressPart1Arr.join(' ')}${addressPart2Arr.join(' ')}`;
      newLabel = newLabel.replace('Australia', '');

      return newLabel.trim();
    }
    case MAP_DATA_SERVICE_DATA_SET.GNAFLPID: {
      return `${label} (${Util.toTitleCase(customFields.locality)}, ${
        customFields.region
      })`;
    }
    default:
      return label;
  }
};

export const isNeedPin = (
  scope: string,
  label: string,
  customFields: MapPlaceSuggestionCustomFields
) => {
  return (
    (label.indexOf(`${customFields.locality}, ${customFields.region}`) !== 0 &&
      scope === MAP_DATA_SERVICE_DATA_SET.GNAF) ||
    scope === MAP_DATA_SERVICE_DATA_SET.GNAFLPID ||
    scope === 'gps'
  );
};

export const constructArcGISWorldGeocodingLocality = (attr: any) => {
  const addressArray = attr.Match_addr.split(',');
  return addressArray
    .slice(0, addressArray.length - 1)
    .map((item: string) => item.trim())
    .join(', ');
};
